import React from 'react';
import { TouchableOpacity } from 'react-native';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import Text from '../Text';

interface Props {
  errorMessage: string | undefined;
}

const DontKnowCep: React.FC<Props> = ({ errorMessage }) => {
  return (
    <TouchableOpacity
      className={`mb-5 ${errorMessage ? 'mt-6' : ''}`}
      onPress={() =>
        MarisaAppUtils.openUrl(
          'https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php'
        )
      }
    >
      <Text className="text-primary-600 font-medium text-sm">
        Não sei o CEP
      </Text>
    </TouchableOpacity>
  );
};

export default DontKnowCep;
